import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(3),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
      minHeight: 200
    },
    header: {
      marginBottom: theme.spacing(3),
      display: 'flex',
      alignItems: 'center'
    },
    stepper: {
      padding: theme.spacing(2, 0),
      backgroundColor: 'transparent'
    },
    stepContent: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(2)
    },
    currentLocationBadge: {
      marginLeft: theme.spacing(1)
    },
    typeChangeBadge: {
      marginLeft: theme.spacing(1)
    },
    metricsTable: {
      marginTop: theme.spacing(1),
      '& td': {
        padding: theme.spacing(0.5, 1),
        borderBottom: 'none'
      }
    },
    chartCard: {
      padding: theme.spacing(2),
      marginTop: theme.spacing(3)
    },
    chartHeader: {
      marginBottom: theme.spacing(2),
      display: 'flex',
      alignItems: 'center'
    },
    tooltipPaper: {
      padding: theme.spacing(1.5),
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper
    },
    emptyState: {
      padding: theme.spacing(6),
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: theme.spacing(2)
    },
    locationDetails: {
      padding: theme.spacing(1),
      backgroundColor: theme.palette.grey[100],
      borderRadius: theme.shape.borderRadius,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    dateRangeContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2),
      flexWrap: 'wrap'
    },
    dateInfo: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5)
    },
    reasonText: {
      marginTop: theme.spacing(1),
      fontStyle: 'italic'
    }
  })
);
